import { faCheck, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody, CardFooter, CardHeader, colors } from '@heroui/react';

function KeyFeature({
    title,
    points,
    image,
    imageAlt,
    icon,
}: {
    title: string;
    points: string[];
    image: string;
    imageAlt: string;
    icon: IconDefinition;
}) {
    return (
        <Card className='h-full'>
            <CardHeader className='text-center text-3xl font-semibold'>
                <div className=' mx-auto flex flex-col items-center gap-2'>
                    <FontAwesomeIcon icon={icon} color={colors.green[500]} size={'xl'} />
                    {title}
                </div>
            </CardHeader>
            <CardBody className='text-md text-md mt-2 grid gap-y-4'>
                {points?.map(p => {
                    return (
                        <li key={p} className='flex items-center gap-2'>
                            <FontAwesomeIcon icon={faCheck} className='h-5 w-5 shrink-0 text-primary' />
                            <span className='text-default-600'>{p}</span>
                        </li>
                    );
                })}
            </CardBody>
            <CardFooter className=' m-0 p-0 '>
                <img src={image} alt={imageAlt} style={{ width: '100%', height: 'auto' }} />
            </CardFooter>
        </Card>
    );
}

export default KeyFeature;
